
import { ToneDetailsPopupCSSStyleImpl } from './tonedetailspopupcss';
import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler, UIComponentProps } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ToneDetailsPopupViewImpl } from './tonedetailspopupview';
import { ToneDto } from '../../../../core/dto/tonedto';

export enum ToneOptionsType
{
    TONE, PLAYLIST
}

export interface ToneDetailsPopupComponentProps extends UIComponentProps
{
    headerTitle: string;
    toneDto: ToneDto;
    onCloseClick(): void;
}

export interface ToneDetailsPopupComponentHandler extends UIComponentHandler
{
    onCloseClick(): void;
}

export class ToneDetailsPopupComponent extends UIComponentImpl<ToneDetailsPopupComponentProps, UIComponentState, UIDataModel> 
implements ToneDetailsPopupComponentHandler
{
    constructor(props: ToneDetailsPopupComponentProps)
    {
        super(props);
    }
    
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneDetailsPopupViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToneDetailsPopupCSSStyleImpl(applicationContext);
    }

    onCloseClick(): void 
    {
       this.props.onCloseClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tonedetailspopup/tonedetailspopupcomponent.tsx